export default __webpack_public_path__ + "static/media/aa9c1c22e14443be9a8ce068c82104ce1600269059794.1fbefda2.webp";